import { Injectable } from "@angular/core"
import { CHNode } from "../models/node.model"

@Injectable()
export class ColorCodeService {
    public collectionColors: any = {
        defaultBackgroundColor: "#02146a",
        defaultTextColor: "#ffffff",
        defaultDetailsColor: "#2b40cb",
    }

    public getColorForNode(node: CHNode): string {
        let discipline = node.getDiscipline()
        if (discipline) {
            return this.getSubjectColor(discipline.id)
        }
        return this.getPrimaryColor()
    }

    public getSubjectColor(code: number): string {
        switch (code) {
            case 8337:
                return "#486CD8" // Science
            case 3026:
                return "#6A1B9A" // Social Studies
            case 1184:
                return "#B2528C" // Mathematics
            case 1880:
                return "#D6383A" // ELA Writing
            case 8353:
                return "#262626" // Engineering & Tech
            case 2806:
                return "#087B45" // Health and PE
            case 2949:
                return "#007B9B" // Preschool
            case 6708:
                return "#60738A" // Professional Development
            case 2663:
                return "#074D51" // The Arts
            case 6267:
                return "#A31A51" // World Languages
            default:
                return "#2638C4" // Primary Color
        }
    }

    public getPrimaryColor(): string {
        return "#2638C4"
    }

    /**
     * used to get a acceptable light color so that it can be used as background color for subcolletion blocks;
     * @param color example #236745
     */
    public shadeColor(color: string, ratio: number = 10): string {
        return this.convertHexToRgba(color, ratio)
    }

    public convertHexToRgba(hex, opacity): string {
        hex = hex.replace("#", "")
        let r = parseInt(hex.substring(0, 2), 16)
        let g = parseInt(hex.substring(2, 4), 16)
        let b = parseInt(hex.substring(4, 6), 16)

        let result = "rgba(" + r + "," + g + "," + b + "," + opacity / 100 + ")"
        return result
    }

    public isWhite(color: string): boolean {
        if (color === "#fff" || color == "#ffffff") {
            return true
        }
        return false
    }
}
